import { Typography } from '@mui/material'

export const NoResults = (): JSX.Element => (
  <Typography variant='body2' color='text.secondary' sx={{ pl: '16px', py: '16px' }} data-testid='p2pNoResults'>
    No results found.
  </Typography>
)
